
const PULSE_STATE = 'pulse';
const FADEIN_STATE = 'fadein';
const FADEOUT_STATE = 'fadeout';
const MOUSEDOWN_STATE = 'fadeout2';

const DEFAULT_TICK_RATE = 100;
const FADE_TICK_RATE = 16;

const PulseButton = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    $imageSelector: null as any,
    tickLastTime: new Date().getTime(),
    state: {
        currentTickRate: DEFAULT_TICK_RATE,
        currentButtonState: PULSE_STATE,
        currentDirection: 1
    },
    tick: function pulseButtonTick() {
        const currentTime = new Date().getTime();

        if ((currentTime - PulseButton.tickLastTime) < PulseButton.state.currentTickRate) {
            window.requestAnimationFrame(PulseButton.tick);
            return;
        }

        PulseButton.tickLastTime = currentTime;

        PulseButton.animate();

        window.requestAnimationFrame(PulseButton.tick);
    },
    // eslint-disable-next-line complexity
    animate: function pulseButtonAnimate() {
        let opacity = parseFloat(PulseButton.$imageSelector.css('opacity'));

        switch (PulseButton.state.currentButtonState) {
            case PULSE_STATE:
                PulseButton.state.currentTickRate = DEFAULT_TICK_RATE;

                if (opacity === 1) {
                    PulseButton.state.currentDirection = 0;
                } else if (opacity === 0) {
                    PulseButton.state.currentDirection = 1;
                }

                if (PulseButton.state.currentDirection) {
                    opacity += 0.1;
                } else {
                    opacity -= 0.1;
                }

                PulseButton.$imageSelector.css('opacity', opacity);

                break;
            case FADEIN_STATE:
                PulseButton.state.currentTickRate = FADE_TICK_RATE;

                if (opacity !== 1) {
                    opacity += 0.1;
                    PulseButton.$imageSelector.css('opacity', opacity);
                } else {
                    PulseButton.state.currentButtonState = null;
                }

                break;
            case FADEOUT_STATE:
                if (opacity !== 0) {
                    opacity -= 0.1;
                    PulseButton.$imageSelector.css('opacity', opacity);
                } else {
                    PulseButton.state.currentButtonState = PULSE_STATE;
                }

                break;
            case MOUSEDOWN_STATE:
                PulseButton.state.currentTickRate = FADE_TICK_RATE;

                if (opacity !== 0) {
                    opacity -= 0.1;
                    PulseButton.$imageSelector.css('opacity', opacity);
                } else {
                    PulseButton.state.currentButtonState = null;
                }

                break;
        }
    },
    start: function startPulseAnimation($hoverContainer: JQuery, $imageSelector: JQuery) {
        PulseButton.$imageSelector = $imageSelector;

        $hoverContainer.on('mouseover', function setFadeInState() {
            PulseButton.state.currentButtonState = FADEIN_STATE;
        });

        $hoverContainer.on('mouseleave', function setFadeOutState() {
            PulseButton.state.currentButtonState = FADEOUT_STATE;
        });

        $hoverContainer.on('mousedown', function setMouseDownState() {
            PulseButton.state.currentButtonState = MOUSEDOWN_STATE;
        });

        $hoverContainer.on('mouseup', function setFadeInState() {
            PulseButton.state.currentButtonState = FADEIN_STATE;
        });

        if (!window.requestAnimationFrame) {
            window.requestAnimationFrame = (function handlePulseRequestAnimationFrame() {
                return window.requestAnimationFrame ||
                    // @ts-ignore
                    window.webkitRequestAnimationFrame ||
                    // @ts-ignore
                    window.mozRequestAnimationFrame ||
                    // @ts-ignore
                    window.oRequestAnimationFrame ||
                    // @ts-ignore
                    window.msRequestAnimationFrame ||
                    // eslint-disable-next-line
                    function (/* function FrameRequestCallback */ callback: Function, /* DOMElement Element */ _element: HTMLElement) {
                        window.setTimeout(callback, 1000 / 60);
                    };
            })();
        }

        window.requestAnimationFrame(PulseButton.tick);
    }
};

export default PulseButton;

export function initPulseButton() {
    PulseButton.start(
        $('.flashing-button'),
        $('.flashing-button-anim-pulse')
    );
}
